import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerAdmin } from '../services/api';

const Register = ({ setIsAuthenticated, setRoleId, setUserId }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact_number: '',
    password: '',
    password_confirmation: '',
    role: 'user',
    profile_picture: null,

    // Vendor only
    shop_name: '',
    shop_email: '',
    shop_contact_number: '',
    shop_address: ''
  });

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    // Handle file input
    if (name === 'profile_picture') {
      setFormData(prev => ({
        ...prev,
        profile_picture: files[0]
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    if (!formData.profile_picture) {
      setError('Profile picture is required');
      setIsLoading(false);
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      setError('Passwords do not match');
      setIsLoading(false);
      return;
    }

    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters');
      setIsLoading(false);
      return;
    }

    /**
     * ✅ BUILD CLEAN PAYLOAD
     */
    const payload = new FormData();

      payload.append('name', formData.name);
      payload.append('email', formData.email);
      payload.append('contact_number', String(formData.contact_number));
      payload.append('password', formData.password);
      payload.append('password_confirmation', formData.password_confirmation);
      payload.append('role', formData.role);
      payload.append('profile_picture', formData.profile_picture);

    // ✅ Add vendor fields ONLY if role is vendor
    if (formData.role === 'vendor') {
      payload.append('shop_name', formData.shop_name);
      payload.append('shop_email', formData.shop_email || '');
      payload.append(
        'shop_contact_number',
        formData.shop_contact_number
          ? String(formData.shop_contact_number)
          : ''
      );
      payload.append('shop_address', formData.shop_address || '');
    }

    try {
      const response = await registerAdmin(payload);

      if (response?.token) {
        localStorage.setItem('adminToken', response.token);
        localStorage.setItem('roleId', response.role_id);
        localStorage.setItem('userId', response.user_id);

        setIsAuthenticated(true);
        setRoleId(Number(response.role_id));
        setUserId(Number(response.user_id));

        navigate(response.role_id === 1 ? '/dashboard' : '/user-profile');
      } else {
        setError('Registration successful but no token received');
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        err?.message ||
        'Registration failed. Please try again.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xxl-4 col-xl-5 col-md-6 d-md-block d-none ps-0">
          <div className="login-image">
            <div className="login-logo">
              <h4 className="text-white">Logo</h4>
            </div>
            <div className="login-content">
              <h3 className="text-white head-xs font-600">
                “Sending money worldwide is now instant, secure, and effortless.”
              </h3>
              <p className="text-white text-sm font-400 pt-2">
                Send, receive, and relax — your money’s already there.
              </p>
            </div>
          </div>
        </div>

        <div className="col-xxl-8 col-xl-7 col-md-6">
          <div className="row vh-100 align-items-center justify-content-center">
            <div className="col-xxl-6 col-xl-10">
              <div className="p-4">
                <div className="text-center pb-4">
                  <h3 className="theme-text-black head-sm font-600 pb-2">
                    Get Started With Paytm
                  </h3>
                  <p className="theme-text-color text-sm font-500 pb-2">
                    Sign up in minutes and start sending money effortlessly worldwide.
                  </p>
                </div>

                {error && (
                  <div className="alert alert-danger text-center py-2">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit} className='register-form'>

                  {/* Role Selection */}
                  <div className="pb-3">
                    <label className="form-label">Register As</label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="form-select"
                    >
                      <option value="user">User</option>
                      <option value="vendor">Vendor</option>
                    </select>
                  </div>

                  {/* Common Fields */}

                  {/* Profile Picture */}
                  <div className="pb-3">
                    <label className="form-label">
                      Profile Picture <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      name="profile_picture"
                      accept="image/*"
                      required
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div className="pb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      name="name"
                      type="text"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div className="pb-3">
                    <label className="form-label">Email address</label>
                    <input
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="pb-3">
                        <label className="form-label">Contact Number</label>
                        <input
                          name="contact_number"
                          type="text"
                          required
                          value={formData.contact_number}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter mobile number"
                        />
                      </div>


                  {/* Vendor Fields */}
                  {formData.role === 'vendor' && (
                    <>
                      <div className="pb-3">
                        <label className="form-label">Shop Name</label>
                        <input
                          name="shop_name"
                          type="text"
                          required
                          value={formData.shop_name}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="pb-3">
                        <label className="form-label">Shop Email</label>
                        <input
                          name="shop_email"
                          type="email"
                          value={formData.shop_email}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="pb-3">
                        <label className="form-label">Shop Contact Number</label>
                        <input
                          name="shop_contact_number"
                          type="text"
                          value={formData.shop_contact_number}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="pb-3">
                        <label className="form-label">Shop Address</label>
                        <textarea
                          name="shop_address"
                          value={formData.shop_address}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>
                    </>
                  )}

                  {/* Passwords */}
                  <div className="pb-3">
                    <label className="form-label">Password</label>
                    <input
                      name="password"
                      type="password"
                      required
                      minLength="8"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div className="pb-4">
                    <label className="form-label">Confirm Password</label>
                    <input
                      name="password_confirmation"
                      type="password"
                      required
                      minLength="8"
                      value={formData.password_confirmation}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isLoading}
                    className={`theme-btn w-100 justify-content-center  ${isLoading ? 'disabled opacity-75' : ''}`}
                  >
                    {isLoading ? 'Processing...' : 'Register'}
                  </button>


                  <div className="login-divider mt-3">
                    <p>Or</p>
                  </div>

                  <div className="text-center">
                    <span className="text-muted">Already have an account? </span>
                    <Link to="/login" className="text-primary fw-semibold">
                      Sign in
                    </Link>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
